import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUser } from '@/shared/hooks/useUser';
import { LogoLoading } from '@/shared/ui/custom/logo-loading';

const PrivateRoute = () => {
  const location = useLocation();
  const { user, loading, error } = useUser();
  
  // Show loading state while checking user
  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <LogoLoading 
          variant="breathing" 
          size="xl" 
          message="Checking authentication..." 
        />
      </div>
    );
  }

  // Handle errors or missing user data
  if (error || !user) {
    // Clear token if not already done
    localStorage.removeItem('token');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Admin/staff can access all routes
  if (user.is_staff || user.is_superuser) {
    return (
      <div className="min-h-screen bg-neutral-50">
        <Outlet />
      </div>
    );
  }

  // User is authenticated, render the protected content
  return (
    <div className="min-h-screen bg-neutral-50">
      <Outlet />
    </div>
  );
};

export default PrivateRoute;